export default "__VITE_ASSET__272697c0__"